var YoutubeBackgrounds = (function () {

    var _opts = {
        selector: '.js-video-background',
        player: null,
        start: 0,
        end: 0,
        loop: false
    };

    var _restartVideo = function (player, settings) {
        player.seekTo( settings.start );
    };

    var _onChange = function (e, settings) {

        // We know that the video is starting, so we get the current time and
        // subtract that from the videos duration to give us a loop duration.
        var loopDuration = Math.round( e.target.getDuration() - Number(e.target.getCurrentTime()) );

        if( settings.loop ) {
            // console.log( "We've set a timeout for " + loopDuration + 's to restart the video' );
            setTimeout(function () {
                // console.log( 'Restarted the video' );
                _restartVideo( e.target, settings );
            }, loopDuration * 1000);
        }
    };

    var _addEvents = function () {

        $( _opts.selector ).each(function () {
            var $this = $( this );
            var player_data = $this.data();

            $this.YTPlayer({
                // fitToBackground: true,
                videoId: player_data.videoId,
                playerVars: {
                    modestbranding: 0,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    branding: 0,
                    rel: 0,
                    autohide: 0,
                    start: player_data.start || 0,
                },
                events: {
                    'onStateChange': function (event) {
                        // One the video is started we setup the onchange event
                        if (event.target.getPlayerState() === 1) {
                            _onChange( event, player_data );
                        }
                    }
                }
            });

        });

    };


    var init = function () {
        if( $( _opts.selector ).length ) _addEvents();
    };

    return {
        init: init
    }

})();


$( document ).ready( YoutubeBackgrounds.init );